/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Catalog_Scope_ClientInputs */

const en_task_catalog_scope_client = /** @type {(inputs: Task_Catalog_Scope_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clients`)
};

const pt_br2_task_catalog_scope_client = /** @type {(inputs: Task_Catalog_Scope_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clientes`)
};

/**
* | output |
* | --- |
* | "Clients" |
*
* @param {Task_Catalog_Scope_ClientInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_catalog_scope_client = /** @type {((inputs?: Task_Catalog_Scope_ClientInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Catalog_Scope_ClientInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_catalog_scope_client(inputs)
	return pt_br2_task_catalog_scope_client(inputs)
});